import t from "./highrise640.mjs";
import o from "./highrise641.mjs";
import f from "./highrise642.mjs";
import i from "./highrise643.mjs";
import e from "./highrise644.mjs";
function c(r) {
  return typeof r == "function" ? r : r == null ? f : typeof r == "object" ? i(r) ? o(r[0], r[1]) : t(r) : e(r);
}
export {
  c as default
};
